import React from 'react';
import { connect } from 'react-redux';
import MainRoute from '../routes/mainRoute';
import VisitorRoute from '../routes/visitorRoute';
import Welcome from './Welcome/Welcome';
import { handleInvalidToken } from '../utils/LoginToken';
import MainLayout from './MainLayout/MainLayout';

const mapStateToProps = (state) => ({
  loginStatus: state.root.loginStatus,
  loginData: state.root.loginData,
});

const App = (props) => {
  return (
    <div>
      {props.loginStatus === 0 ? <Welcome /> : null}
      {props.loginStatus === 1 ? <MainRoute /> : null}
      {props.loginStatus === 2 ? <VisitorRoute /> : null}
    </div>
  );
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/views/app.jsx